import React from 'react';
const DownloadIcon = () =>
  <div style={{ width: 16, height: 16 }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 30 30">
      <g id="Resident-booking-site-UI-(smartphone-version)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
        <g id="Tenant-booking-site-(smartphone-version)" transform="translate(-30.000000, -753.000000)" stroke="#1C4CA1">
          <g id="Group-4" transform="translate(16.000000, 744.000000)">
            <g id="Group-2" transform="translate(14.000000, 7.000000)">
              <g id="data-download" transform="translate(0.000000, 2.000000)">
                <polygon id="Path" points="3.5 6.5 8 11.5 12.5 6.5 9.5 6.5 9.5 0.5 6.5 0.5 6.5 6.5"></polygon>
                <path d="M15.5,10.5 L15.5,14.5 C15.5,15.052 15.052,15.5 14.5,15.5 L1.5,15.5 C0.948,15.5 0.5,15.052 0.5,14.5 L0.5,10.5" id="Path"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
export default DownloadIcon;